<template>
	<div>
		  <el-table
		    :data="tableData"
		    max-height="305px"
		    border
		    style="width: 100%">
			<el-table-column
			  align="center"
			  prop="typelist"
			  label="类型"
			  width="100">
			  <template slot-scope="props">
			  	{{type(props.row.typelist)}}
			  </template>
			</el-table-column>
			<el-table-column
			  align="center"
			  prop="hangye_id"
			  label="行业"
			  width="100">
			  <template slot-scope="props">
			  	{{props.row.hangye}}
			  </template>
			</el-table-column>
			<el-table-column
			  align="center"
			  prop="title"
			  label="标题">
			  <template slot-scope="props">
			  	<el-link type="primary" @click="$router.push('/details/id/'+props.row.Id)" :underline="false">{{props.row.title.slice(0,36)}}</el-link>
			  </template>
			</el-table-column>
		    <el-table-column
			  align="center"
		      prop="createtime"
		      label="日期"
		      width="120">
			  <template slot-scope="props">
			  	{{$utils.timestampToTimes(props.row.starttime*1000)}}
			  </template>
		    </el-table-column>
			<el-table-column
			  align="center"
			  prop="address"
			  label="操作"
			  width="120">
			  <template slot-scope="props">
				  <div class="oprate">
					  <div class="pay" @click="pay('wechat','scan',props.row.Id)" v-if="props.row.status == 0">支付</div>
					  <div class="pay" v-if="props.row.status == 1">待审核</div>
					  <div class="pay" v-if="props.row.status == 2">未开始</div>
					  <div class="pay" v-if="props.row.status == 3">进行中</div>
					  <div class="pay" v-if="props.row.status == 4">已结束</div>
					  <div class="del" @click="del(props.row.Id)">删除</div>
				  </div>

			  </template>
			</el-table-column>
		  </el-table>
		  <!-- 支付二维码弹出 -->
		  <el-dialog
		    title="微信扫码支付"
		    :visible.sync="isPay"
		    width="300px">
		    <span> <img :src="payurl" alt="" style="display: block;margin:auto;width:90%"> </span>
		    <span slot="footer" class="dialog-footer">
		      <el-button type="primary" @click="isPay = false">确 定</el-button>
		    </span>
		  </el-dialog>
	</div>

</template>

<script>
  export default {
	metaInfo() {
	  return {
		title: '管理项目 - ' + this.metaName,
		meta: [
		  { charset: "utf-8" },
		  { name: "keywords", content: this.metaKeywords },
		  { name: "description", content: this.metaDecs },
		],
	  };
	},
    data() {
      return {
		userInfo:{},
		flag:false,
		isPay:false,
		payurl:'',
		domain:this.$utils.httpUrl,
		metaName: "",
		metaKeywords: "",
		metaDecs: "",
        tableData: []
      }
    },
	mounted() {
		this.$axios({
			url:this.$utils.httpApi + 'index/webconfig'
		}).then(res=>{
			this.metaName = res.data.data.webtitle
			this.metaDecs = res.data.data.webdescription
			this.metaKeywords = res.data.data.webkeywords
		})
		if(!window.localStorage.getItem('token')){
			this.$message({
				message:'请先登录！',
				type:'error'
			})
			this.$router.push('/')
		}
	},
	created() {
		if(window.localStorage.getItem("token")){
			this.$axios({
				url:this.$utils.httpApi + 'user/getinfos',
				headers:{
					'token':window.localStorage.getItem("token")
				}
			}).then(res=>{
				this.userInfo = res.data
				this.getMyZhaoBiao(res.data.id)
			})	
		}
		
	},
	methods:{
		type(stat){
			if(stat == 0){
				return '招标公告'
			}else if(stat == 1){
				return '散单需求'
			}
		},
		pay(type,meth,id){
			  this.$axios({
				  method:'post',
				  url:this.$utils.httpApi + 'order/pay',
				  data:{
					  flag:0,
					  article_id:id,
					  user_id:this.userInfo.id,
					  title:'发布项目费用',
					  type:type,
					  meth:meth
				  }
			  }).then(res=>{
				  if(res.data.code == 1){
					  this.isPay = true
					  this.payurl=this.domain + '/qrcode/build?text='+ res.data.data.code_url
					  setTimeout(res=>{
						  this.isPay = false
					  },30000)
				  }else{
					  this.$message({
						  message:res.data.msg,
						  type:'error'
					  })
				  }
			  })
		  },
		getMyZhaoBiao(id){
		    this.$axios({
			   method:'post',
			   url:this.$utils.httpApi + 'about/getmyzhaobiao',
			   data:{'id':id},
			   headers:{
			   	'token':window.localStorage.getItem("token")
			   }
		    }).then(res=>{
			   this.tableData = res.data.data
		    })
		},
		del(id){
			this.$axios({
				method:'post',
				url:this.$utils.httpApi + 'about/delMyZhaoBiao',
				data:{'id':id,'user_id':this.userInfo.id},
				headers:{
					'token':window.localStorage.getItem("token")
				}
			}).then(res=>{
				if(res.data.code == 1){
					this.$message({
						message:res.data.msg,
						type:'success'
					})
					window.location.reload()
				}else{
					this.$message({
						message:res.data.msg,
						type:'error'
					})
				}
			})
		}
	}
  }
</script>

<style scoped>
	.oprate{
		display: flex;
		justify-content: center;
	}
	.del,.pay{
		width:40%;
		cursor:pointer;
		color:red;
	}
	.pay{
		color:#000;
		width:100%;
	}
</style>